import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const PEOPLE_SEEK = [{
  emoji: '🧘‍♀️',
  text: 'Equilibrio emocional'
}, {
  emoji: '🌿',
  text: 'Terapias energéticas'
}, {
  emoji: '💬',
  text: 'Acompañamiento holístico'
}];
const CAREER_BENEFITS = ['Realizar sesiones de Reiki', 'Atender presencial o a distancia', 'Trabajar desde casa', 'Complementar ingresos', 'Construir tu propio espacio terapéutico'];
export function CareerSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#1a1a2e] py-14 md:py-20 px-4 border-t border-white/5" data-id="element-85">
      <div className="container mx-auto max-w-4xl" data-id="element-86">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-87">
          <span className="text-[#f0c040] text-sm font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-88">
            💼 Salida Laboral
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-89">
            Sí, puedes convertir esto en una herramienta profesional
          </h2>
          <p className="text-xl text-gray-400 leading-relaxed max-w-2xl mx-auto" data-id="element-90">
            El bienestar y las terapias alternativas están en crecimiento 📈
          </p>
        </div>

        <div ref={ref2} className={`reveal bg-[#252538] rounded-3xl p-8 md:p-12 shadow-lg border border-white/10 ${vis2 ? 'is-visible' : ''}`} data-id="element-91">
          {/* What people seek */}
          <div className="text-center mb-6" data-id="element-92">
            <p className="text-lg text-gray-300 mb-4" data-id="element-93">
              Cada vez más personas buscan:
            </p>
            <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-94">
              {PEOPLE_SEEK.map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-[#1e1e30] px-5 py-3 rounded-xl border border-white/5" data-id="element-95">
                  <span className="text-xl" data-id="element-96">{item.emoji}</span>
                  <span className="text-gray-200 font-medium" data-id="element-97">{item.text}</span>
                </div>)}
            </div>
          </div>

          {/* What you can do */}
          <div className="mb-8" data-id="element-98">
            <p className="text-center text-lg text-gray-300 mb-4" data-id="element-99">
              Con esta formación podrás:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-100">
              {CAREER_BENEFITS.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-101">
                  <div className="bg-[#d4a017]/20 p-1.5 rounded-full flex-shrink-0" data-id="element-102">
                    <CheckIcon className="w-4 h-4 text-[#f0c040]" strokeWidth={3} data-id="element-103" />
                  </div>
                  <span className="text-gray-200 font-medium" data-id="element-104">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="text-center border-t border-white/10 pt-6" data-id="element-105">
            <p className="text-xl md:text-2xl font-serif font-bold text-white mb-2" data-id="element-106">
              No compras información. Adquieres una habilidad.
            </p>
            <p className="text-lg text-[#f0c040] font-medium" data-id="element-107">
              Y las habilidades generan ingresos 💰
            </p>
          </div>
        </div>
      </div>
    </section>;
}